import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import Breadcrumbs from '../Components/banner/New-banner';
import Wishlist from '../Components/wishlist/Wish';
function WishlistPage() {
  return (
    <>
      <Combaintop />
      <Breadcrumbs />
      <Wishlist/>
      <Combainbottom/>
    </>
  )
}

export default WishlistPage;